export default __webpack_public_path__ + "navigation-examples-waypoint-arrival-screen-1200-fd4919ac52b2e60d8cba8b9731b7997b.webp";